import React, {useState} from 'react'
import { Box } from '@mui/material';
function ImageBlock({id,type,properties}) {
  return (
     <Box
            sx={{
              textAlign: properties.textAlign || 'center',
              padding:  `${properties.padding.top}px ${properties.padding.right}px ${properties.padding.bottom}px ${properties.padding.left}px`,
              margin:  `${properties.margin.top}px ${properties.margin.right}px ${properties.margin.bottom}px ${properties.margin.left}px`,
              backgroundColor: properties.backgroundColor || 'transparent',
             
            }}
           
          >
            <img
              src={properties.src || 'https://picsum.photos/200'}
              alt={properties.alt || 'Image description'}
              style={{
                width: properties.width || '200px',
                height: properties.height || 'auto',
                borderRadius: properties.imgborderRadius || '0px',
                display: 'inline-block',
                margin:
                  properties.align === 'center'
                    ? '0 auto'
                    : properties.align === 'right'
                    ? '0 0 0 auto'
                    : '0',
              }}
            />
          </Box>
  )
}

export default ImageBlock